import React from 'react';
import { getRol } from '../../_utils/storage_handler';

const RolWrapper = (AuthComponent, roles) => (
    class extends React.Component{

        validateRol = () => {
            if(roles.findIndex(r => r === getRol()) !== -1){
                return true;
            }
            return false;
        }

        render(){
            if(this.validateRol()){                
                return(<AuthComponent {...this.props} />);
            } else {
                return(
                    <></>
                );
            }
        }
    }
);

export default RolWrapper;